import {useAnalytics} from '@github-ui/use-analytics'
import {InfoIcon} from '@primer/octicons-react'
import {AnchoredOverlay, IconButton} from '@primer/react'
import {useCallback, useState} from 'react'

import styles from './IssueTypeEvent.module.css'

type IssueEventRationaleProps = {
  rationale: string
  issueEventDatabaseId: string
  analyticsAction: string
  target?: string | null
}

export function IssueEventRationale({
  rationale,
  issueEventDatabaseId,
  analyticsAction,
  target,
}: IssueEventRationaleProps) {
  const [showRationale, setShowRationale] = useState(false)
  const {sendAnalyticsEvent} = useAnalytics()

  const toggleRationale = useCallback(() => {
    setShowRationale(prev => {
      const next = !prev
      if (next) {
        sendAnalyticsEvent('issue_viewer.timeline.rationale_click', analyticsAction, {
          issueEventDatabaseId,
          target,
          rationaleLength: rationale.length,
        })
      }
      return next
    })
  }, [sendAnalyticsEvent, analyticsAction, issueEventDatabaseId, target, rationale.length])

  const closeRationale = useCallback(() => setShowRationale(false), [])

  return (
    <AnchoredOverlay
      open={showRationale}
      onOpen={toggleRationale}
      onClose={closeRationale}
      renderAnchor={props => (
        // The IconButton opens an AnchoredOverlay containing the actual rationale;
        // a hover tooltip would just duplicate the aria-label. See github/accessibility#8422 for a11y team guidance.
        // eslint-disable-next-line primer-react/a11y-remove-disable-tooltip
        <IconButton
          {...props}
          icon={InfoIcon}
          variant="invisible"
          size="small"
          aria-label="Rationale"
          unsafeDisableTooltip
          className={styles.rationaleIcon}
        />
      )}
    >
      <div className={styles.rationaleOverlay}>{rationale}</div>
    </AnchoredOverlay>
  )
}
